import FluidHeader from './FluidHeader'
import MobileMenu from './MobileMenu'
import LazyLoad from 'vanilla-lazyload'
// import initSlider from './Slider'
import initScrollSlide from './ScrollSlide'
import initSwiper from './Swiper'
import Flip from './Button'
import initScrollStickyCards from './ScrollStickyCards'
import CurrentElement from './CurrentElement'
import FloatSlider from './FloatSlider'
import SliderImages from './SliderImages'
import Accordion from './Accordion'
import Breadcrumb from './Breadcrumb'
import FilterOffers from './FilterOffers'
import AutoScroll from './AutoScroll'
import FixedButton from './FixedButton'
import AjaxsScript from './AjaxsScript'
import FancyboxInit from './FancyboxInit'

window.addEventListener('load', () => {
  if (window.location.hash) {
    const element = document.querySelector(window.location.hash)
    if (element) {
      element.scrollIntoView()
    }
  } else {
    window.scrollTo(0, 0)
  }
})

$(document).ready(() => {
  const myLazyLoad = new LazyLoad()
  FancyboxInit()
  MobileMenu()
  FluidHeader()
  // initSlider()
  initScrollSlide()
  initSwiper()
  Flip()
  initScrollStickyCards()
  CurrentElement()
  FloatSlider()
  SliderImages()
  Accordion()
  Breadcrumb()
  FilterOffers()
  AutoScroll()
  FixedButton()
  AjaxsScript()
})
